import http from './api'

const route = 'app/cliente/'

export default {
  showDadosClienteFaturados: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento) => {
    return http.post(route + 'showDadosClienteFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
    })
  },

  showClienteDevolucaoImpropria: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento) => {
    return http.post(route + 'showClienteDevolucaoImpropria', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
    })
  },

  showDetalheClientesDevolucaoImpropriaNFF: (primeiroDia, ultimoDia, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento) => {
    return http.post(route + 'showDetalheClientesDevolucaoImpropriaFF', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
    })
  },
}
